/**
 * Makes a fetch request to Cryptoys data platform with headers and credentials.
 * @param {string} url - The URL to fetch.
 * @param {Object} options - The fetch options.
 * @param {string} options.didToken - The DID token from Magic.
 * @param {string} options.recaptchaToken - The reCAPTCHA token.
 * @param {string} options.correlationId - The correlation ID.
 * @param {Object} options.headers - Additional headers.
 * @returns {Promise<Response>} - The fetch response.
 */
export const dataPlatformFetch = async (
  url,
  { didToken, recaptchaToken, correlationId, ...otherOptions }
) => {
  const headers = {
    'Content-Type': 'application/json',
    ...(didToken && { Authorization: `Bearer ${didToken}` }),
    ...(recaptchaToken && { 'x-recaptcha-v3-token': recaptchaToken }),
    ...(correlationId && { 'x-correlation-group': correlationId }),
    ...otherOptions.headers
  };

  const response = await fetch(url, {
    ...otherOptions,
    headers,
    credentials: 'include'
  });

  return response;
};

export default dataPlatformFetch;
